import {
	appReducer,
	AppStore,
	buildRootStore,
	FETCHING_MIDDLEWARES,
} from 'common/redux'
import type { WindowView } from './model/presenter-url'
import { createRelay, Relay } from './replication/relay'
import { withRemoteState } from './replication/remote-state'
import { ROOT_SYNC_POLICY } from './root-sync-policy'

export type WindowStore = {
	store: AppStore
	/** The console's relay to the presentation window; none in that window. */
	relay: Relay | null
}

/**
 * The store for what this window is. The trainer's main window - and every
 * other ordinary window - gets the app's store with a relay at the end. The
 * presentation window is fed the console's state instead: its reducer takes
 * the console's slices, and the middlewares that fetch on eventbus events
 * are left out - their results arrive from the console.
 */
export const buildWindowStore = (role: WindowView['role']): WindowStore => {
	if (role === 'projector') {
		return {
			store: buildRootStore({
				reducer: withRemoteState(appReducer, ROOT_SYNC_POLICY),
				middleware: [],
			}),
			relay: null,
		}
	}
	const relay = createRelay()
	return {
		store: buildRootStore({
			middleware: [...FETCHING_MIDDLEWARES, relay.middleware],
		}),
		relay,
	}
}
